import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommonLookupService } from '../../services/lookup/common-lookup.service';
import { GlobalDataService } from '../../services/global/global-data.service';
import { GlobalService } from '../../services/common/global.service';
import { session } from '../../common/session/session';
import { SelectComponent } from "../select/select.component";
import { MENU_ITEMS } from '../../common/menu-meta';
@Component({
  selector: 'app-sidebar-search',
  imports: [CommonModule,
    FormsModule, SelectComponent],
  templateUrl: './sidebar-search.component.html',
  styleUrl: './sidebar-search.component.css'
})
export class SidebarSearchComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  private commonLookupService = inject(CommonLookupService);
  private globalService = inject(GlobalService);
  private cdr = inject(ChangeDetectorRef); // For change detection
  @Output() practiceSelected = new EventEmitter<string>();
  searchText: string = '';
  filteredPrograms: any[] = [];
  selectedProgram: any = null;
  showDropdown: boolean = false;
  programList: any = [];
  sidebarSearchForm!:FormGroup;

  constructor(private elementRef: ElementRef, public fb:FormBuilder) { }
  initializeSearchForm() {
    this.sidebarSearchForm = this.fb.group({
      sidebarSearch: ['',],
    })
  }
  ngOnInit(): void {
    this.initializeSearchForm();
    this.subscription.add(
      this.commonLookupService.GetPractices().subscribe({
        next: (data) => {
          this.programList = data;
          let practiceValue = this.globalService.getValue(session.practiceValue);
          
          if(practiceValue!= undefined && practiceValue!= "" ){
            this.filteredPrograms =  this.programList.filter((program: any) => program?.id == Number(practiceValue))
            // this.searchText = this.filteredPrograms[0]?.value;
            this.sidebarSearchForm.patchValue({"sidebarSearch":Number(this.filteredPrograms[0].id)})
            this.showPracticeDropDown(this.filteredPrograms[0]?.id);

          }
        }, error: (error) => {
        }
      })
    )
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


  onSearch() {
    const text = this.searchText.toLowerCase().trim();
    this.filteredPrograms = this.programList.filter((program: any) =>
      program?.value?.toLowerCase()?.includes(text)
    );
    this.showDropdown = !!text; 
    this.cdr.detectChanges(); 
  }

  selectProgram(program: any) {
    this.searchText = program.value;
    this.globalService.setValue(session.practiceValue,program.id); // set the global value for practice by id
    this.selectedProgram = program;
    this.filteredPrograms = [];
    this.showDropdown = false;
    this.cdr.detectChanges();
  }
  onFocus() {
    this.onSearch(); 
    this.showDropdown = !!this.searchText || this.filteredPrograms.length > 0;
    this.cdr.detectChanges();
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
      this.cdr.detectChanges();
    }
  }

  selectChangedEvent(e:any){
    // let res = e.split(":")[1].trim();
    const selected = this.programList.find((program: any) => program.value === e);
    const selectedId = selected ? selected.id : null;
    this.globalService.setValue(session.practiceValue,selectedId); 
    this.practiceSelected.emit(e);
    this.showPracticeDropDown(e);
  }
  showPracticeDropDown(res:any){
    if(res!=""){
      // let menuItem = MENU_ITEMS;
      // let result = menuItem.filter((item: any) => item.label == "Practice Panel");
      // if(result.length>0){
      //   result[0].showChildren = true
      // }
      this.practiceSelected.emit(res);

    }
  }
}
